function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Horst, Netherlands coordinates
const latitude = 51.453667;
const longitude = 6.050344;

// Function to fetch sunrise and sunset times and convert them to GMT+2
const fetchSunTimes = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (lat, lng) {
    try {
      const response = yield fetch(`https://api.sunrise-sunset.org/json?lat=${lat}&lng=${lng}&formatted=0`);
      const data = yield response.json();
      const sunriseUTC = new Date(data.results.sunrise);
      const sunsetUTC = new Date(data.results.sunset);
      const sunrise = new Date(sunriseUTC.setHours(sunriseUTC.getHours() + 2)); // Adjust for GMT+2
      const sunset = new Date(sunsetUTC.setHours(sunsetUTC.getHours() + 2)); // Adjust for GMT+2

      return {
        sunrise,
        sunset
      };
    } catch (error) {
      console.error('Failed to fetch sun times:', error);
      return null;
    }
  });
  return function fetchSunTimes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
const initDarkmode = () => {
  // Check for saved 'darkMode' in localStorage
  let darkMode = localStorage.getItem('darkMode');
  const darkModeToggles = document.querySelectorAll('.js-switch-mode');
  const enableDarkMode = () => {
    let DarkModeTime = new Date();
    DarkModeTime.setHours(DarkModeTime.getHours() + 2);
    document.body.classList.remove('is-lightness');
    document.body.classList.add('is-darkness');
    localStorage.setItem('darkMode', 'enabled');
    document.cookie = `darkMode=true; expires=${DarkModeTime.toUTCString()}; path=/`;
  };
  const enableLightMode = () => {
    let DarkModeTime = new Date();
    DarkModeTime.setHours(DarkModeTime.getHours() + 2);
    document.body.classList.remove('is-darkness');
    document.body.classList.add('is-lightness');
    localStorage.setItem('darkMode', null);
    document.cookie = `darkMode=false; expires=${DarkModeTime.toUTCString()}; path=/`;
  };

  // Set initial mode based on localStorage
  if (darkMode === 'enabled') {
    enableDarkMode();
  } else {
    enableLightMode();
  }

  // Handle toggle clicks
  darkModeToggles.forEach(toggle => {
    toggle.addEventListener('click', event => {
      event.preventDefault();
      document.body.classList.add('mode-transition');
      setTimeout(() => {
        darkMode = localStorage.getItem('darkMode');
        if (darkMode !== 'enabled') {
          enableDarkMode();
        } else {
          enableLightMode();
        }
      }, 1);
      setTimeout(() => {
        document.body.classList.remove('mode-transition');
      }, 600);
    });
  });

  // Initialize auto dark mode based on sunrise/sunset
  const initAutoMode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      const times = yield fetchSunTimes(latitude, longitude);
      if (!times) return;
      const now = new Date();
      if (now > times.sunrise && now < times.sunset) {
        enableLightMode();
      } else {
        enableDarkMode();
      }
    });
    return function initAutoMode() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!document.cookie.split('; ').find(row => row.startsWith('darkMode='))) {
    // Call initAutoMode immediately
    initAutoMode();
  }
};
export { initDarkmode as default };